import React, { memo } from "react";
import { Box } from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";

const GoogleTrailMap = ({ points = [], height }) => {
	if (!Array.isArray(points) || points.length === 0) {
		return (
			<Box
				sx={{
					height: height || "400px",
					display: "grid",
					placeContent: "center",
				}}
			>
				Waiting for sufficient data...
			</Box>
		);
	}

	const lastPoint = points[points.length - 1];

	const containerStyle = {
		width: "100%",
		height: height || "400px",
		borderRadius: "12px",
	};

	const keyForPoint = (p, i) =>
		`${p.id ?? p.ts ?? "na"}:${Number(p.lat).toFixed(6)},${Number(
			p.lng
		).toFixed(6)}#${i}`;

	return (
		<Box
			sx={{
				boxShadow: 1,
				borderRadius: 0,
				overflow: "hidden",
				height: containerStyle.height,
			}}
		>
			<GoogleMap
				key={`${lastPoint.lat}-${lastPoint.lng}`}
				mapContainerStyle={containerStyle}
				center={lastPoint}
				zoom={16}
				options={{
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					rotateControl: false,
					scaleControl: false,
					zoomControl: true,
				}}
			>
				{points.length > 1 &&
					points.slice(0, -1).map((p, i) => (
						<Marker
							key={keyForPoint(p, i)}
							position={{ lat: p.lat, lng: p.lng }}
							icon={{
								path: window.google.maps.SymbolPath.CIRCLE,
								scale: 8,
								fillColor: "#3498db",
								fillOpacity: 1,
								strokeColor: "#3498db",
								strokeWeight: 2,
								zIndex: i,
							}}
						/>
					))}

				{lastPoint && (
					<Marker
						key={`last:${keyForPoint(
							lastPoint,
							points.length - 1
						)}`}
						position={lastPoint}
						icon={{
							path: window.google.maps.SymbolPath.CIRCLE,
							scale: 8,
							fillColor: "#e74c3c",
							fillOpacity: 1,
							strokeColor: "#e74c3c",
							strokeWeight: 2,
							zIndex: 200,
						}}
						zIndex={window.google.maps.Marker.MAX_ZINDEX + 1}
					/>
				)}
			</GoogleMap>
		</Box>
	);
};

const arePointsEqual = (prevProps, nextProps) => {
	const a = prevProps.points || [];
	const b = nextProps.points || [];
	if (a.length !== b.length) return false;
	if (a.length === 0) return true;
	const al = a[a.length - 1];
	const bl = b[b.length - 1];
	return al.lat === bl.lat && al.lng === bl.lng;
};

export default memo(GoogleTrailMap, arePointsEqual);
